module.exports = __webpack_public_path__ + "assets/images/5d8cebd7c8a220869d1255510c348554.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/urology-times.png
// module id = 417
// module chunks = 0